import React from 'react';
import { useFormikContext } from 'formik';

const OrganizersSelectList = ({
  field,
  label,
  SearchComponent,
  ListComponent,
  placeholder,
  ...selectProps
}) => {
  const { values, setFieldValue } = useFormikContext();
  const organizers = values[field];

  const onChange = (selected) => {
    setFieldValue(field, [...organizers, selected]);
  };

  const onDelete = (selected) => {
    setFieldValue(
      field,
      organizers.filter(
        (value) =>
          (value._id && selected._id && value._id !== selected._id) ||
          (value.id && selected.id && value.id !== selected.id)
      )
    );
  };

  return (
    <>
      <SearchComponent
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...selectProps}
        label={label}
        field={field}
        selectedUsers={organizers}
        onChange={onChange}
        placeholder={placeholder}
      />
      {organizers.length > 0 && (
        <div className="pt-4">
          <ListComponent users={organizers} onDelete={onDelete} isEditable />
        </div>
      )}
    </>
  );
};

export default OrganizersSelectList;
